export class User {
  hasConsentAccount: boolean;
  hasConsentWidget: boolean;
  hasSites: boolean;
  isAdmin: boolean;
  isSiteAdmin: boolean;

  public equals(user: User): boolean {
    if (!user) {
      return false;
    }
    return (
      this.hasConsentAccount === user.hasConsentAccount &&
      this.hasConsentWidget === user.hasConsentWidget &&
      this.hasSites === user.hasSites &&
      this.isAdmin === user.isAdmin &&
      this.isSiteAdmin === user.isSiteAdmin
    );
  }
}
